import React, { useState } from 'react';
import { ShieldAlert, ChevronRight } from 'lucide-react';
import api from '@/utils/api';
import { Button } from '@/components/ui/button';
import { ptDate } from '@/utils/pioneerDates';

// Empresas com NIF em falta ou inválido; o selo «Verificada» só é retirado depois de confirmar (nenhuma conta é apagada).
export const NifAuditPanel = () => {
  const [items, setItems] = useState(null);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const revoke = () => {
    setLoading(true);
    api.post('/admin/employers/nif-audit/revoke', { confirm: true })
      .then((r) => { setItems(r.data.items || []); setConfirming(false); })
      .finally(() => setLoading(false));
  };
  const load = () => { setLoading(true); api.get('/admin/employers/nif-audit').then((r) => { setItems(r.data.items || []); setOpen(true); }).finally(() => setLoading(false)); };
  const removed = (items || []).filter((i) => i.badge_removed_at);
  const withBadge = (items || []).filter((i) => i.has_badge);
  return (
    <div className="mb-6 rounded-xl border border-red-200 bg-white p-4" data-testid="nif-audit-panel">
      <div className="flex flex-wrap items-center gap-3">
        {items && <button type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open} data-testid="nif-audit-toggle"><ChevronRight className={`h-4 w-4 text-red-600 transition-transform ${open ? 'rotate-90' : ''}`} /></button>}
        <ShieldAlert className="h-4 w-4 text-red-600" />
        <p className="flex-1 font-bold text-slate-900">Revisão de NIF {items && <span className="font-normal text-sm text-slate-500">· {items.length} com NIF inválido/em falta · {removed.length} sem selo</span>}</p>
        <Button size="sm" variant="outline" onClick={load} disabled={loading} data-testid="nif-audit-run">{items ? 'Actualizar' : 'Ver empresas com NIF inválido'}</Button>
        {withBadge.length > 0 && !confirming && <Button size="sm" variant="destructive" onClick={() => setConfirming(true)} data-testid="nif-audit-revoke-btn">Retirar selo a {withBadge.length}</Button>}
      </div>
      {confirming && (
        <div className="mt-3 flex flex-wrap items-center gap-2 rounded-lg bg-red-50 p-3 text-sm text-red-800" data-testid="nif-audit-confirm-box">
          <span className="flex-1">Retirar o selo «Verificada» a {withBadge.length} empresa(s) com NIF inválido/em falta? Nenhuma conta é apagada.</span>
          <Button size="sm" variant="outline" onClick={() => setConfirming(false)} data-testid="nif-audit-confirm-cancel">Cancelar</Button>
          <Button size="sm" variant="destructive" onClick={revoke} disabled={loading} data-testid="nif-audit-confirm-revoke">Confirmar</Button>
        </div>
      )}
      {items && open && (
        <div className="mt-3 overflow-x-auto">
          {items.length === 0 ? <p className="text-sm text-emerald-700" data-testid="nif-audit-empty">Todas as empresas têm um NIF válido para o país.</p> : (
            <table className="w-full text-sm" data-testid="nif-audit-table">
              <thead className="text-left text-xs uppercase text-slate-400"><tr><th className="pb-2">Empresa</th><th className="pb-2">Email</th><th className="pb-2">País</th><th className="pb-2">NIF</th><th className="pb-2">Problema</th><th className="pb-2">Selo</th></tr></thead>
              <tbody>
                {items.map((i) => (
                  <tr key={i.id} className="border-t border-slate-100" data-testid={`nif-audit-row-${i.id}`}>
                    <td className="py-1.5 pr-3 font-semibold">{i.company_name || '—'}</td><td className="py-1.5 pr-3 text-slate-500">{i.email}</td>
                    <td className="py-1.5 pr-3">{i.country}</td><td className="py-1.5 pr-3 font-mono">{i.fiscal_nif || '—'}</td>
                    <td className="py-1.5 pr-3 text-red-700">{i.problem}</td><td className="py-1.5">{i.has_badge ? 'Ainda tem selo' : i.badge_removed_at ? `Retirado ${ptDate(i.badge_removed_at)}` : '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
};
